import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  
  const testimonials = [
    {
      text: "In questo periodo così difficile per l'affitto di un immobile ci siamo rivolti a Federico persona molto gentile che in poco tempo è riuscito a trovare la soluzione giusta per noi. Grazie",
      author: "Mariarca Di Martino",
      location: ""
    },
    {
      text: "Affidabilità, competenza, serietà, mi sono sentita accolta e seguita in tutto l'iter. Grazie di cuore!",
      author: "Lucilla Bernardi",
      location: ""
    },
    {
      text: "Appena completato una transazione. Estremamente raccomandabile. Federico si è prodigato per fornire tutte le necessarie informazioni in tempo reale, disponibile, gentile e professionale … un piacere averlo conosciuto…. 5 stelle se le merita tutte !!!",
      author: "Simone Berni",
      location: ""
    },
    {
      text: "Ho chiamato l'agenzia perché avevo bisogno di trovare un'appartamento il prima possibile a Scandicci. L'agente che mi ha seguita è stato molto gentile e disponibile. Se avevo qualche dubbio mi ha aiutato a capire e risolvere. Sono rimasta molto soddisfatta e li contatterò sicuramente se avrò ancora bisogno di trovare casa.",
      author: "Maria Rosaura Esposito",
      location: "Scandicci"
    }
  ];
  
  const nextTestimonial = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };
  
  const prevTestimonial = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };
  
  return (
    <section className="py-20 bg-gray-50 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-bl-full"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-secondary/5 rounded-tr-full"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <span className="text-secondary uppercase tracking-wider font-semibold">Testimonianze</span>
          <h2 className="text-4xl font-monomakh text-primary mt-2 mb-4">La Voce dei Nostri Clienti</h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Scopri cosa dicono i nostri clienti della loro esperienza con Molinaro Immobiliare.
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto relative">
          <div className="absolute top-1/2 left-0 transform -translate-y-1/2 -translate-x-4 md:-translate-x-12 z-20">
            <button 
              onClick={prevTestimonial}
              className="w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-primary hover:text-white transition-colors"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
          </div>
          
          <div className="absolute top-1/2 right-0 transform -translate-y-1/2 translate-x-4 md:translate-x-12 z-20">
            <button 
              onClick={nextTestimonial}
              className="w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-primary hover:text-white transition-colors"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
          
          <div className="relative overflow-hidden rounded-xl shadow-xl">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${activeIndex * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div key={index} className="min-w-full">
                  <div className="bg-white p-10 md:p-16 flex flex-col md:flex-row items-center">
                    <div className="md:w-1/3 mb-6 md:mb-0 flex justify-center">
                      <div className="relative w-32 h-32 rounded-full bg-primary/10 flex items-center justify-center border-4 border-gray-100">
                        <Quote className="h-12 w-12 text-primary/40" />
                      </div>
                    </div>
                    <div className="md:w-2/3 md:pl-10">
                      <div className="flex space-x-1 mb-4">
                        {[...Array(5)].map((_, i) => (
                          <Star key={i} className="h-5 w-5 text-secondary fill-current" />
                        ))}
                      </div>
                      <p className="text-gray-600 mb-6 italic text-lg leading-relaxed">"{testimonial.text}"</p>
                      <div>
                        <h4 className="font-semibold text-primary text-xl">{testimonial.author}</h4>
                        {testimonial.location && <p className="text-gray-500">{testimonial.location}</p>}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === activeIndex ? 'bg-primary w-6' : 'bg-gray-300 hover:bg-gray-400'
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;